/**
 * Make an asynchronous request to an Endpoint. This is mainly intended to be used by other services
 *
 *
 * @param {joki} jokiInstance - An instance of joki where the EndpointService is subsrcibed
 * @param {string} id - The endpoint ID that is triggered
 * @param {Object} [options] - Options for the request
 * @param {string} [options.endpointServiceId] - An alternative id for the EndpointService requested. Defaults to EndpointService.
 * @param {Object} [options.filters] - More filters added to this request by key value pairs in an object
 * @param {Object} [options.body] - The body content that the Endpoint sends forward
 * @returns {*} The value returned by the Endpoint
 */
export async function endpointRequest(jokiInstance, id, options = {}) {
    const endpointServiceId = options.endpointServiceId || 'EndpointService';
    const filters = options.filters || {};
    const body = options.body || undefined;
    const urlParse = options.urlParse || undefined;
    const contentType = options.contentType || undefined;

    if (jokiInstance.isJokiInstance !== true) {
        throw new Error(`The first argument for endpointRequest must an instance of Joki.`);
    }

    if (typeof id !== 'string') {
        throw new Error(`Argument id for endpointRequest must be a string`);
    }

    const results = await jokiInstance.ask({
        to: endpointServiceId,
        key: 'endpointRequest',
        body: {
            id: id,
            filters: filters,
            body: body,
            urlParse: urlParse,
            contentType
        },
    });

    if (results[endpointServiceId] === undefined) {
        // console.warn(`Service "${endpointServiceId}" defined for endpoint id "${id}" is undefined`);
        console.warn(`EndpointFunctions: Results for id ${id} did not include any results from ${endpointServiceId}}`);
        return undefined;
    }

    if (results[endpointServiceId].then === undefined) {
        return results[endpointServiceId];
    }

    try {
        const [finalResults, error] = await results[endpointServiceId];

        if (error) {
            console.warn('error', error);

            throw new Error(`EndpointFunctions:endpointRequest: ${error}`);
        }
        return finalResults;
    } catch (err) {
        console.warn("ID:", id);
        console.warn("OPTIONS:", options);
        console.warn("RESULST", results);
        console.error("ERROR:EndpointFunctions:endpointRequest", err);
        throw err;
    }
}
